<template>
  <detail-layout ref="layout" :tableCfg="tableCfg">
    <template slot="FormLayout" scope="props">
      <b-form ref="form" class="col-md-6 offset-md-2" autocomplete="off">
        <div v-if="dataValid" >
          <detail-field label="Intake" field="intake" :optionListApiUrl="'/contracts_intake/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Scholarship" field="scholarship_id" :optionListApiUrl="'/scholarships/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Year" field="year" :optionListApiUrl="'/contracts_year/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Date" field="milestone_date" :rec="props.rec" :isReadOnly="isReadOnly" type="date" vvalidate="ok" :validator="validator"/>
          <detail-field label="Amount" field="milestone_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
        </div>
      </b-form>
    </template>
  </detail-layout>
</template>

<script>
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'program_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?9a2f6ab8